import { Component } from '@angular/core';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-join-onboarding',
  templateUrl: './join-onboarding.component.html',
  styleUrls: ['./join-onboarding.component.scss'],
})

/**
 * Onboarding join program
 */
export class JoinOnboardingComponent {
  RouterKeys = RoutesKeys;
}
